var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKebab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "5px",
    height: "25px",
    viewBox: "0 0 5 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u21B3 \uD83C\uDFA8 Icon color Copy 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Events",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Event-List_Simple_Mobile",
    transform: "translate(-330.000000, -1400.000000)",
    fill: "#3f6d6e"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Event-1-Copy",
    transform: "translate(20.000000, 1084.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 51.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.5,285 C313.880712,285 315,286.119288 315,287.5 C315,288.880712 313.880712,290 312.5,290 C311.119288,290 310,288.880712 310,287.5 C310,286.119288 311.119288,285 312.5,285 Z M312.5,275 C313.880712,275 315,276.119288 315,277.5 C315,278.880712 313.880712,280 312.5,280 C311.119288,280 310,278.880712 310,277.5 C310,276.119288 311.119288,275 312.5,275 Z M312.5,265 C313.880712,265 315,266.119288 315,267.5 C315,268.880712 313.880712,270 312.5,270 C311.119288,270 310,268.880712 310,267.5 C310,266.119288 311.119288,265 312.5,265 Z",
    id: "\\u21B3-\\uD83C\\uDFA8-Icon-color-Copy-8"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKebab);
export default __webpack_public_path__ + "static/media/Kebab.c5edc770beeeaaccd03eb78066452ee5.svg";
export { ForwardRef as ReactComponent };